<template>
  <div class="view">
    <div class="content">
      <div class="condition" v-if="false">
        <div class="search_wrap">         
          <el-form :inline="true" :model="formdata" class="form-inline whd-order-form">          
            <el-form-item>
              <el-input
                placeholder="请输入内容"
                v-model="formdata.content"
                class="input-with-select"
                size="small"
              >
                <el-select
                  v-model="formdata.content_type"
                  slot="prepend"
                  placeholder="请选择内容类型"
                  size="small"
                >
                  <el-option
                    v-for="(item,index) in contenttype"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="是否是积分订单">
                <el-select
                    v-model="formdata.is_points_pay"
                    placeholder="请选择订单类型"
                    size="small"
                  >
                    <el-option
                      v-for="(item,index) in pointstype"
                      :label="item.label"
                      :value="item.value"
                      :key="index"
                    ></el-option>
                  </el-select>
            </el-form-item>              
            <el-form-item label="商品名称">
              <el-input v-model="formdata.goods_name" placeholder="请输入商品名称" size="small"></el-input>
            </el-form-item>
            <el-form-item label="名片主">
              <el-input v-model="formdata.user_name" placeholder="请输入名片主" size="small"></el-input>
            </el-form-item>
            <el-form-item label="完成时间">
              <el-date-picker
                v-model="formdata.finishtime"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="下单时间">
              <el-date-picker
                v-model="formdata.ordertime"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="condition" v-if="false">
        <div class="check_wrap">
          <el-radio-group v-model="formdata.type" @change="changetype" size="small">
            <el-radio-button
              v-for="(item,index) in ordertype"
              :label="item.value"
              :key="index"
            >{{item.label}}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="other_wrap">
          <el-button type="primary" @click="exportfile" size="small">导出</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="goods_id" label="商品编号"></el-table-column>
          <!-- <el-table-column label=" 商品图片 / 商品名称 / 单价 / 数量" width="350">     
            <template slot-scope="scope">
              <div class="weui-cells">
                <div v-for="(item,index) in scope.row.goods_info" :key="index" class="weui-cell">
                  <div class="weui-cell__hd"><img :src="item.goods_thumb" /></div>
                  <div class="weui-cell__bd">{{item.goods_name}}</div>
                  <div class="weui-cell__ft">{{item.price}}/{{item.goods_number}}</div>
                </div>
              </div>
            </template>  
          </el-table-column>           -->
          <!-- <el-table-column label="商品图片">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.goods_thumb" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称"></el-table-column>
          <el-table-column prop="goods_number" label="单价/数量" width="120"></el-table-column> -->
          <el-table-column prop="shop_price" label="用户名称">
            <template  slot-scope="scope">
              <p>{{scope.row.user.nickName}}</p>
          </template>
          </el-table-column>
          <el-table-column prop="shop_price" label="用户名称">
            <template  slot-scope="scope">
              <p>{{scope.row.user.nickName}}</p>
          </template>
          </el-table-column>
          <el-table-column label="图片" align="center">
						<template slot-scope="scope">
							<div class="td_img">
								<img :src="scope.row.pics" alt />
							</div>
						</template>
					</el-table-column>
          <!-- <el-table-column prop="shipping_fee" label="运费"></el-table-column>
          <el-table-column prop="money_paid" label="应付"></el-table-column>
          <el-table-column prop="discount" label="优惠"></el-table-column>
          <el-table-column prop="card_id" label="名片主"></el-table-column>
          <el-table-column  label="佣金/接收者">
            <template slot-scope="scope">
              <p>{{scope.row.commission}}</p>
              <p>
                {{scope.row.commission_xcx_name}} 
                <span v-if="scope.row.commission_xcx_name && scope.row.commission_employee_name "> / </span> 
                {{scope.row.commission_employee_name}}
                </p>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="配送" width="200"></el-table-column> -->
          <el-table-column prop="" label="收货人" width="170">
            <template  slot-scope="scope">
                <p>收件人：{{scope.row.shipping_name}}</p>
                <p>手机号：{{scope.row.shipping_phone}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="order_status" label="状态"></el-table-column>
          <el-table-column label="操作" width="160" align="center" fixed="right" >
            <template slot-scope="scope">
              <!-- v-if="is_out == 0" -->
              <el-button type="text" size="small" @click="detail(scope.row.id)">编辑</el-button>
              <el-button
                type="text"
                size="small"
                @click="download(scope.row.id)"
              >下载</el-button>
              <!-- <el-button
                v-if="scope.row.state===0"
                type="text"
                size="small"
                @click="forbid(scope.row.id)"
              >禁用</el-button>
              <el-button
                v-if="scope.row.state===1"
                type="text"
                size="small"
                @click="resume(scope.row.id)"
              >恢复</el-button>
              <el-button
                v-if="scope.row.type==0 && scope.row.address && (scope.row.order_status==='待发货' || (scope.row.order_status==='已拒绝' && scope.row.is_send==0))"
                type="text"
                size="small"
                @click="delivery(scope.row.id)"
              >发货</el-button>
              <el-button
              v-if="scope.row.write_off==1 && scope.row.order_status==='待发货'"
              type="text" size="small" @click="writeoff(scope.row.id)">核销</el-button> -->

            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
        <!-- <el-dialog title="核销" v-if="dialogTableVisible" :visible.sync="dialogTableVisible" @deliverysuccess="deliverysuccess">
        <div class="dialog_conwrap dialog_auth">
          <p>是否确定核销</p>
          <p><br/></p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="save()">确 定</el-button>
          </span>
        </div>
      </el-dialog> -->
      </div>
    </div>
    <deliveryDialog
      :id="currentid"
      :visible.sync="deliverydialog"
      v-if="deliverydialog"
      @deliverysuccess="deliverysuccess"
    ></deliveryDialog>
  </div>
</template>
<script>
import api from "@/api.js";
import { pagination, ordertype, contenttype } from "@/util/util.js";
import deliveryDialog from "@/components/dialog/deliveryDialog.vue";
export default {
  name: "customOrderList",
  props: ["visible", "id"],
  components: {
    deliveryDialog
  },
  data() {
    return {
      contenttype: contenttype,
      ordertype: ordertype,
      pointstype: [
        { label: '不是', value: 0 },
        { label: '是', value: 1 }
      ],
      formdata: {
        is_points_pay: 0,
        content_type: "",
        content: "",
        type: 0,
        goods_name: "",
        user_name: "",
        finishtime: "",
        ordertime: ""
      },
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
        },
      },
      currentid: "",
      deliverydialog: false,
      dialogTableVisible: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    //初始化请求
    search() {
      this.page.pageindex = 1;
      this.querylist();
    },
    // 获取时间
    getdate(date) {
      let res = {
        start: "",
        end: ""
      };
      if (date && date.length > 0) {
        res.start = date[0];
        res.end = date[1];
      }
      return res;
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex,
        type: this.formdata.type,
        content_type: this.formdata.content_type,
        is_points_pay: this.formdata.is_points_pay,
        content: this.formdata.content,
        goods_name: this.formdata.goods_name,
        user_name: this.formdata.user_name,
        finish_start: this.getdate(this.formdata.finishtime).start,
        finish_end: this.getdate(this.formdata.finishtime).end,
        order_start: this.getdate(this.formdata.ordertime).start,
        order_end: this.getdate(this.formdata.ordertime).end
      };
      this.axios
        .post(api.make_user_list, params)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.is_out = response.data.is_out
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 核销
    writeoff(id) {
      let params = {
        order_id: id
      };
      this.axios
        .post(api.order_writeOff, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "核销成功",
              type: "success"
            });
            this.querylist();
          } else {
          }
        })
        .catch(() => {});
    },
    
    // save() {
    //   let params = {
    //     order_id: id
    //   };
    //   this.axios
    //     .post(api.order_writeOff, params)
    //     .then(response => {
    //       if (response.data.code == 0) {
    //         this.$message({
    //           message: "核销成功",
    //           type: "success"
    //         });
    //         this.$emit("deliverysuccess");
    //         this.dialogVisible = false;
    //       } else {
    //       }
    //     })
    //     .catch(() => {});
    // },
    // 切换类型查询
    changetype() {
      this.page.pageindex = 1;
      this.querylist();
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    // 详情
    detail(id) {
      this.$router.push({ name: "userCustomTemplate", query: { id: id } });
    },
    del(id) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.sumbitDel(id);
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "已取消删除"
          });
        });
    },
    // 删除
    sumbitDel(id) {
      let params = {
        order_id: id
      };
      this.axios
        .post(api.order_delete, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.querylist();
          } else {
          }
        })
        .catch(() => {});
    },
    // 禁用
    download(id) {
      let params = {
        id: id
      };
      this.axios
        .post(api.make_user_download, params)
        .then(response => {
          if (response.data.code == 0) {
            // window.location.href = response.data.data
            window.open(response.data.data)
          } else {
          }
        })
        .catch(() => {});
    },
    // 恢复
    resume(id) {
      let params = {
        order_id: id
      };
      this.axios
        .post(api.order_resume, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "恢复成功",
              type: "success"
            });
            this.querylist();
          } else {
          }
        })
        .catch(() => {});
    },
    // 发货
    delivery(id) {
      this.currentid = id;
      this.deliverydialog = true;
    },
    // 发货成功回调
    deliverysuccess() {
      this.querylist();
    },
    // 导出
    exportfile() {
      this.axios.get(api.order_out_excel,{
        params:{
          'page':this.page.pageindex,
          'type':this.formdata.type,
          'content_type':this.formdata.content_type,
          'is_points_pay':this.formdata.is_points_pay,
          'content':this.formdata.content,
          'goods_name':this.formdata.goods_name,
          'user_name':this.formdata.user_name,
          'finish_start':this.getdate(this.formdata.finishtime).start,
          'finish_end':this.getdate(this.formdata.finishtime).end,
          'order_start':this.getdate(this.formdata.ordertime).start,
          'order_end':this.getdate(this.formdata.ordertime).end
        },
        responseType: "arraybuffer"
      })
          .then(
              function(response) {
                let filename = "订单售后（明细）.xlsx";
                this.fileDownload(response.data, filename);
              }.bind(this)
          )
          .catch(
              function(error) {

              }.bind(this)
          );
    },
    fileDownload (data, fileName) {
      let blob = new Blob([data], {
        type: "application/octet-stream"
      });
      let filename = fileName || "filename.xls";
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        let blobURL = window.URL.createObjectURL(blob);
        let tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", filename);
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      }
    }
  }
};
</script>

<style scoped>
.table_wrap .weui-cells{border: 1px dashed #ebebeb;}
.table_wrap .weui-cell{padding: 10px; border-top: 1px dashed #ebebeb;}
.table_wrap .weui-cell:first-child{border-top: 0;}
.table_wrap .weui-cell__hd img{display: block; width: 60px; height: 60px; object-fit: cover;}
.table_wrap .weui-cell__bd{padding: 0 10px;}
.table_wrap .weui-cell__ft{width: 80px; white-space: nowrap;}
</style>